export default __webpack_public_path__ + "static/media/ultraserv2.231e3342.jpg";